const isMobile = window.innerWidth < 700;

export default isMobile
